module.exports = __webpack_public_path__ + "media/img/Vector-1-c48d57bd.svg";